import enumFactory from "@util/enumFactory";
export default enumFactory.createEnum({
    BEFORE_LIVE: {
        code: 1,
        title: '未开始'
    },
    IN_LIVE: {
        code: 2,
        title: '进行中'
    },
    AFTER_LIVE: {
        code: 3,
        title: '已结束'
    }
});
